const GET_FLEET_ITEM_CANCEL = 'GET_FLEET_ITEM_CANCEL'
const SET_FLEET_ITEM_CANCEL = 'SET_FLEET_ITEM_CANCEL'

const GET_ASSET_FLEET_ITEM_CANCEL = 'GET_ASSET_FLEET_ITEM_CANCEL'
const SET_ASSET_FLEET_ITEM_CANCEL = 'SET_ASSET_FLEET_ITEM_CANCEL'

const GET_AFE_FLEET_ITEM_CANCEL = 'GET_AFE_FLEET_ITEM_CANCEL'

export {
    GET_FLEET_ITEM_CANCEL,
    SET_FLEET_ITEM_CANCEL,
    GET_ASSET_FLEET_ITEM_CANCEL,
    SET_ASSET_FLEET_ITEM_CANCEL,
    GET_AFE_FLEET_ITEM_CANCEL
}
